
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12.335 13.749a6.5 6.5 0 111.414-1.414l4.458 4.458a1 1 0 01-1.414 1.414l-4.458-4.458zM13 8.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0z","fill":"currentColor"}})])
          )
        }
      }
    